import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { EmbersTablePagination } from './pagination/tablePagination';
import { EmbersTableResultsPerPage } from './resultsPerPage/tableResultsPerPage';
import { EmbersTableRefreshIndicator } from './refreshIndicator/tableRefreshIndicator';
import { EmbersTableLoadMore } from './loadMore/tableLoadMore';
import { useWindowSize } from '../../utils/resizeHook';
import { StyledTableBottomControls } from './tableBottomControlsStyles';
var WIDTTH = 560;
var HEIGHT = 32;
export var EmbersTableBottomControls = function EmbersTableBottomControls(props) {
  var lastUpdated = props.lastUpdated,
    onPaginationChange = props.onPaginationChange,
    pageCount = props.pageCount,
    currentPage = props.currentPage,
    onResultsPerPageChange = props.onResultsPerPageChange,
    resultsPerPage = props.resultsPerPage,
    resultsPerPageOptions = props.resultsPerPageOptions,
    loadMoreStep = props.loadMoreStep,
    _props$showLoadMore = props.showLoadMore,
    showLoadMore = _props$showLoadMore === void 0 ? false : _props$showLoadMore,
    mixpanelProps = props.mixpanelProps,
    message = props.message,
    className = props.className;
  var refreshIndicatorProps = {
    lastUpdated: lastUpdated
  };
  var paginationProps = {
    onPaginationChange: onPaginationChange,
    pageCount: pageCount,
    currentPage: currentPage,
    mixpanelProps: mixpanelProps
  };
  var resultsPerPageProps = {
    onResultsPerPageChange: onResultsPerPageChange,
    resultsPerPage: resultsPerPage,
    resultsPerPageOptions: resultsPerPageOptions,
    pageCount: pageCount,
    mixpanelProps: mixpanelProps
  };
  var loadMoreProps = {
    onResultsPerPageChange: onResultsPerPageChange,
    resultsPerPage: resultsPerPage,
    pageCount: pageCount,
    loadMoreStep: loadMoreStep,
    mixpanelProps: mixpanelProps
  };
  var size = useWindowSize();
  var _useState = useState({
      width: 0,
      height: HEIGHT
    }),
    _useState2 = _slicedToArray(_useState, 2),
    containerSize = _useState2[0],
    setContainerSize = _useState2[1];
  var ref = useRef(null);
  useEffect(function () {
    ref.current && setContainerSize({
      width: ref.current.clientWidth,
      height: ref.current.clientHeight
    });
  }, [ref, size]);
  return /*#__PURE__*/React.createElement(StyledTableBottomControls, {
    ref: ref,
    className: classnames('EmbersTableBottomControls-root', {
      sm: containerSize.width < WIDTTH,
      'word-break': containerSize.width >= WIDTTH && containerSize.height > HEIGHT,
      'with-load-more': showLoadMore && pageCount && pageCount > 1
    }, className)
  }, /*#__PURE__*/React.createElement(EmbersTableRefreshIndicator, refreshIndicatorProps), showLoadMore ? /*#__PURE__*/React.createElement(EmbersTableLoadMore, loadMoreProps) : message ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EmbersTablePagination, paginationProps), /*#__PURE__*/React.createElement(EmbersTableResultsPerPage, resultsPerPageProps)));
};